module.exports = __webpack_public_path__ + "img/login.65f09dc6.jpg";